module.exports = __webpack_public_path__ + "static/img/img_09.a6f8c75d.png";